import { useCallback } from 'react';
import ls from 'local-storage';
import moment from 'moment';
import { useDispatch } from 'redux-react-hook';
import { GUEST_ROUTES } from 'routes/routes';
import { updateUser } from 'store/DEPRECATEDusers/asyncAction';
import { errorAlert, infoAlert } from 'ui-kit/Alert';

import TrackingAPI from '../api/TrackingAPI';

export const useScenarioApi = (
  currentUser,
  navigate,
  {
    requestScenario,
    isLegalRequest,
    createWizardGame
  }
) => {
  const dispatch = useDispatch();

  const checkIfLegal = useCallback(async (data) => {
    const { data: isLegal } = await isLegalRequest(data);
    if (isLegal === false) {
      errorAlert('Restricted content. Terms of use violation. Please try different text.');
    }
    return isLegal;
  }, [isLegalRequest]);

  const handleScenarioCreation = useCallback(async ({
    scriptName,
    scenarioIdea,
    playerName,
    charactersNames,
    setup,
    charactersDescription,
    location,
    initialMessages,
    charactersAvatars,
    gamesCreated,
    playerDescription
  }) => {
    TrackingAPI.trackEvent('custom_scenario_start_generate');

    const createdToday = gamesCreated?.filter(
      t => moment(t?.timestamp).unix() >= moment().startOf('day').unix()
    );
    if (createdToday.length >= 10) {
      infoAlert('You have reached the daily limit of 10 scenarios');
      TrackingAPI.trackEvent('custom_scenario_finish_daily_limit');
      return;
    }

    const avatars = {};
    for (const key in charactersAvatars) {
      avatars[key.toLowerCase()] = { default: charactersAvatars[key] };
    }

    const appearance = {};
    for (const key in charactersDescription) {
      appearance[key.toLowerCase()] = charactersDescription[key];
    }

    const newUserData = {};
    let shouldUpdateUser = false;
    if (currentUser?.characterName !== playerName) {
      newUserData.characterName = playerName;
      shouldUpdateUser = true;
    }
    if (
      currentUser?.characterDescription === null ||
      currentUser?.characterDescription === ''
    ) {
      if (playerDescription !== '') {
        newUserData.characterDescription = playerDescription;
        shouldUpdateUser = true;
      }
    }

    if (shouldUpdateUser) {
      await dispatch(updateUser({ ...newUserData, id: currentUser?.id }));
    }

    const { data: config } = await requestScenario({
      scenarioIdea,
      playerName,
      aiNames: charactersNames,
      setup,
      characters: charactersDescription,
      location,
      initialMessages,
      avatars,
      appearance
    });

    if (!config) {
      errorAlert('Something went wrong, try again later');
      TrackingAPI.trackEvent('custom_scenario_finish_error');
      return;
    }

    const aiNames = charactersNames?.map(x => x?.toLowerCase());
    try {
      config.initial_messages = config.initial_messages?.map(x =>
        x?.name === 'Narrator' ? { role: 'assistant', text: x?.text } : x
      );
      config.initial_messages = config.initial_messages?.map(x =>
        x?.name === playerName ? { ...x, extra: { isUser: true } } : x
      );
      config.system_message_parts = {
        ...config.system_message_parts,
        characters_description: {
          ...charactersDescription,
          '{{user}}': playerDescription
        }
      };
      config.ai_names = aiNames;
      config.name = scriptName;
      config.scenario_name = scriptName;
      config.post_message =
        'USER: Please generate a message that contains only one idea that is expressed in only two speech and maybe two actions, but not more. ';
    } catch (_error) {
  
    }

    const creationData = {
      userId: currentUser.id,
      name: scriptName,
      description: scenarioIdea,
      publicName: scriptName,
      publicDescription: scenarioIdea
    };

    try {
      const { data } = await createWizardGame({ data: creationData, configJson: config });
      if (data?.game) {
        TrackingAPI.trackEvent('custom_scenario_finish');
        navigate(GUEST_ROUTES.ROLEPLAY(data.game.alias));
        ls.remove('scenario_wizard_data');
        ls.remove('scenario_wizard_step');
      }
    } catch (_error) {
      errorAlert('Something went wrong, try again later');
      TrackingAPI.trackEvent('custom_scenario_wizard_finish_error');
    }
  }, [currentUser, navigate, dispatch, requestScenario, createWizardGame]);

  return {
    checkIfLegal,
    handleScenarioCreation
  };
}; 